import { createContext, useContext } from 'react';

export const RequestListContext = createContext({ list: [], isLoading: false });

export const useRequestList = () => useContext(RequestListContext);
